(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fika-header-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', event => { if(event.key==='Escape') document.querySelectorAll('.fika-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();}); });
  } catch(e) { console.error(e); }
})();

})();
